module.exports = __webpack_public_path__ + "static/blockchain-c6cb90af2740dbb4d5a454b4241f83d1.png";